import script from "./Preview.vue?vue&type=script&setup=true&lang=ts"
export * from "./Preview.vue?vue&type=script&setup=true&lang=ts"

export default script